module.exports = __webpack_public_path__ + "img/logo-2.b9248f69.png";